import React, { useState, useEffect } from 'react';
import LoadingOverlay from '../../../components/shared/LoadingOverlay';
import EmptyState from '../../../components/shared/EmptyState';
import { toast } from '../../../components/shared/toast';
import { apiClient } from '../../../api/apiClient';
import { GET_LOGS_URL } from '../../../api/settings';

function UserLogsSubTab({ searchQuery }) {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchLogs = async () => {
    try {
      setIsLoading(true);
      const res = await apiClient(`${GET_LOGS_URL}?search=${encodeURIComponent(searchQuery || '')}`);
      setLogs(res?.logs || []);
    } catch (err) {
      console.error('Error fetching user logs:', err);
      toast.error('Failed to load user activity logs');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [searchQuery]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#0f172a', margin: 0 }}>
            System Audit & User Logs
          </h2>
          <p style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0 0' }}>
            Chronological audit trail of user actions, role changes, and system operations.
          </p>
        </div>

        <button
          type="button"
          className="action-btn-outlined"
          onClick={fetchLogs}
          style={{ padding: '8px 16px', fontSize: '13px', fontWeight: '600' }}
        >
          🔄 Refresh Logs
        </button>
      </div>

      {isLoading ? (
        <LoadingOverlay isLoading={true} message="Loading User Logs..." />
      ) : logs.length === 0 ? (
        <EmptyState title="No User Logs Found" message="User actions and audit records will appear here." />
      ) : (
        <div className="table-responsive-container" style={{ backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <th style={{ padding: '14px 20px', fontWeight: '700', color: '#475569' }}>Timestamp</th>
                <th style={{ padding: '14px 20px', fontWeight: '700', color: '#475569' }}>Username</th>
                <th style={{ padding: '14px 20px', fontWeight: '700', color: '#475569' }}>Action</th>
                <th style={{ padding: '14px 20px', fontWeight: '700', color: '#475569' }}>Details</th>
                <th style={{ padding: '14px 20px', fontWeight: '700', color: '#475569', textAlign: 'right' }}>IP Address</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '14px 20px', color: '#64748b', whiteSpace: 'nowrap' }}>
                    {log.created_at ? new Date(log.created_at).toLocaleString() : '—'}
                  </td>
                  <td style={{ padding: '14px 20px', fontWeight: '600', color: '#0f172a' }}>
                    @{log.username || 'System'}
                  </td>
                  <td style={{ padding: '14px 20px' }}>
                    <span style={{ backgroundColor: '#f1f5f9', color: '#1e293b', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase' }}>
                      {log.action}
                    </span>
                  </td>
                  <td style={{ padding: '14px 20px', color: '#334155' }}>
                    {log.details || '—'}
                  </td>
                  <td style={{ padding: '14px 20px', color: '#94a3b8', textAlign: 'right', fontFamily: 'monospace' }}>
                    {log.ip_address || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default UserLogsSubTab;
